<nav class="navbar navbar-default" style="height:50px;display: flex;flex-flow: row wrap;align-items: center;justify-content: space-between;">
    <div class="navbar-header">
        <h2>Liste mit aktuellen Verträgen</h2>
    </div>
    <div class="navbar-collapse collapse">
        <div class="nav navbar-nav navbar-right">
            <mat-form-field>
                <mat-select (change)="OnSelectedRealEstate($event)" [(ngModel)]="selectedRealEstate" placeholder="WHA zu exportieren">
                    <mat-option [value]="DEFAULT_REALESTATE_FILTER"> Alles </mat-option>
                    <mat-option *ngFor="let realEstate of realEstates" [value]="realEstate.Key">
                        {{realEstate.DisplayName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <button mat-button  (click)="Export()" cdkFocusInitial>Export als Excel</button>
        </div>
    </div>
</nav>
<mat-card-content style="height: calc(100vh - 180px);">
    <ag-grid-angular #agGrid style="width: 100%;height:100%;"  class="ag-theme-blue" [gridOptions]="gridOptions"
        [rowData]="rowData" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</mat-card-content>



// WEBPACK FOOTER //
// ./src/app/_vertrag/vertrag-list/vertrag-list.component.html